module.exports = __webpack_public_path__ + "static/media/mark.867c2844.png";